module.exports = __webpack_public_path__ + "images/mountain-6c9dc34031.png";